var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"top-bar2"},[_c('div',{staticClass:"account-title"},[_vm._v(_vm._s(_vm.$t('account.create_order')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }